import React from 'react';
import { PropTypes } from 'prop-types';
import { ToString, NormalizeClassNameString } from '../utils';

import './styles.scss';

export class ItemDescriptionComponent extends React.Component {
    render() {
        const self = this;
        const {children, iconClass, isHtml, hideIcon} = self.props;

        if (!Boolean(children)) {
            return null;
        }

        const asHtml = isHtml && (typeof children === 'string');

        const className = NormalizeClassNameString('item-description ' + ToString(self.props.className));

        return (
            <div className={className}>
                {!hideIcon && Boolean(iconClass) && <span className={NormalizeClassNameString('description-icon ' + ToString(iconClass))}/>}
                {asHtml && <div className="description-content" dangerouslySetInnerHTML={{__html: children}} />}
                {!asHtml && <div className="description-content">{children}</div>}
            </div>
        );
    }
}
ItemDescriptionComponent.propTypes = {
    iconClass: PropTypes.string,
    className: PropTypes.string,
    isHtml: PropTypes.bool,
    hideIcon: PropTypes.bool,
}
ItemDescriptionComponent.defaultProps = {
    iconClass: 'sbkico-info text-info',
    isHtml: false,
    hideIcon: false,
}